import React, { useEffect, useState, useCallback } from 'react'
import DashboardLayout from '../../layoutcontainers/DashboardLayout'
import { Stack, Grid } from '@mui/system'
import MaterialTypography from '../../components/MaterialTypography'
import MaterialSelect from '../../components/MaterialSelect'
import MaterialDatePicker from '../../components/MaterialDatePicker'
import EmployeeTaskTable from './components/EmployeeTaskTable'
import { BASE_URL } from '../Utils/Baseurl'
import axios from 'axios'
import MaterialBox from '../../components/MaterialBox'
import { IconButton } from '@mui/material'
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';

const EmployeeTask = () => {

    const [filters, setFilters] = useState({
        project_id: "",
        start_date: "",
        end_date: "",
        date: "",
        status: null,
    })

    const [employeeTaskData, setEmployeeTaskData] = useState([]);
    const [projects, setProjects] = useState([]);
    const [taskStatus, setTaskStatus] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRows, setTotalRows] = useState(0);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    const formatDate = (date) => {
        if (!date) return "";
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    const fetchEmployeeTask = useCallback(async (page) => {
        try {
            const token = sessionStorage.getItem("token");
            const user_id = sessionStorage.getItem("currentUser");
            const response = await axios.post(`${BASE_URL}api/getEmployeeTask/`, {
                user_id: user_id,
                project_id: filters.project_id?.value || "",
                start_date: formatDate(filters.start_date),
                end_date: formatDate(filters.end_date),
                actual_date: formatDate(filters.date),
                status: filters.status?.value || "",
            }, {
                params: {
                    page: page,
                    ordering: sortConfig.key ? (sortConfig.direction === 'asc' ? sortConfig.key : `-${sortConfig.key}`) : undefined
                },
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            })

            setEmployeeTaskData(response.data.data);
            setTaskStatus(response.data.task_details);
            setTotalRows(response.data.count || 0);
        } catch (error) {
            console.error('Error fetching employee tasks:', error)
        }
    }, [filters.project_id, filters.start_date, filters.end_date, filters.date, filters.status, sortConfig])

    const fetchEmployeeProjects = async () => {
        try {
            const token = sessionStorage.getItem("token");
            const user_id = sessionStorage.getItem("currentUser");
            const response = await axios.get(`${BASE_URL}api/get_employee_projects/`, {
                params: {
                    user_id: user_id
                },
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            console.log('Employee projects API response:', response.data);

            const projectOptions = response.data?.data?.map(item => ({
                value: item.project_id,
                label: item.project_name
            })) || [];

            setProjects(projectOptions);
        } catch (error) {
            console.error('Error fetching employee projects:', error);
        }
    }

    const handleClearFilter = () => {
        setFilters({
            project_id: "",
            start_date: "",
            end_date: "",
            date: "",
            status: null,
        });
    }

    useEffect(() => {
        fetchEmployeeTask(1)
        fetchEmployeeProjects()
    }, [fetchEmployeeTask])

    useEffect(() => {
        setCurrentPage(1);
        fetchEmployeeTask(1)
    }, [filters.project_id, filters.start_date, filters.end_date, filters.date, filters.status, sortConfig, fetchEmployeeTask])

    return (
        <DashboardLayout>
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
                p={1}
                mb={1}
            >
                <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium" color="dark">
                        Task list
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                        You can view the task list here.
                    </MaterialTypography>
                </Stack>
                <Stack direction="column" spacing={0}>
                    <MaterialBox>

                    </MaterialBox>

                </Stack>
            </Stack>
            <Grid container spacing={2} sx={{ mb: 2, mt: 1, px: 1 }}>
                <Grid size={{ xs: 12, sm: 6, md: 2.25 }}>
                    <Stack spacing={1}>
                        <MaterialTypography variant="caption" color="text" fontWeight="medium">
                            Project
                        </MaterialTypography>
                        <MaterialSelect
                            placeholder="Select Project"
                            size="small"
                            options={projects}
                            value={filters.project_id}
                            onChange={(selectedOption) => setFilters({ ...filters, project_id: selectedOption })}
                        />
                    </Stack>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 2.25 }}>
                    <Stack spacing={1}>
                        <MaterialTypography variant="caption" color="text" fontWeight="medium">
                            Start Date
                        </MaterialTypography>
                        <MaterialDatePicker
                            input={{ placeholder: "Start Date", size: "small" }}
                            value={filters.start_date}
                            onChange={(date) => setFilters({ ...filters, start_date: date })}
                        />
                    </Stack>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 2.25 }}>
                    <Stack spacing={1}>
                        <MaterialTypography variant="caption" color="text" fontWeight="medium">
                            End Date
                        </MaterialTypography>
                        <MaterialDatePicker
                            input={{ placeholder: "End Date", size: "small" }}
                            value={filters.end_date}
                            onChange={(date) => setFilters({ ...filters, end_date: date })}
                        />
                    </Stack>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 2.25 }}>
                    <Stack spacing={1}>
                        <MaterialTypography variant="caption" color="text" fontWeight="medium">
                            Date
                        </MaterialTypography>
                        <MaterialDatePicker
                            input={{ placeholder: "Date", size: "small" }}
                            value={filters.date}
                            onChange={(date) => setFilters({ ...filters, date: date })}
                        />
                    </Stack>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                    <Stack spacing={1}>
                        <MaterialTypography variant="caption" color="text" fontWeight="medium">
                            Status
                        </MaterialTypography>
                        <Stack direction="row" spacing={1} alignItems="center">
                            <MaterialSelect
                                size="small"
                                placeholder="Select Status"
                                value={filters.status}
                                onChange={(selectedOption) => setFilters({ ...filters, status: selectedOption })}
                                options={[
                                    { value: '0', label: 'Not Started' },
                                    { value: '1', label: 'In Progress' },
                                    { value: '3', label: 'On Hold' },
                                    { value: '2', label: 'Completed' },
                                    { value: '4', label: 'Aborted' }
                                ]}
                            />
                            <IconButton
                                onClick={handleClearFilter}
                                sx={{
                                    backgroundColor: '#fff1f2',
                                    '&:hover': { backgroundColor: '#ffe4e6' },
                                    p: 0.8
                                }}
                            >
                                <FilterAltOffIcon sx={{ color: "#F63049", fontSize: '1.2rem' }} />
                            </IconButton>
                        </Stack>
                    </Stack>
                </Grid>
            </Grid>

            {taskStatus && (
                <MaterialBox sx={{ mb: 3, mt: 3, px: 1 }}>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 6, sm: 4, md: 3, lg: 1.5 }}>
                            <MaterialBox sx={{
                                p: 2,
                                backgroundColor: '#e3f2fd',
                                borderRadius: '12px',
                                textAlign: 'center',
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.04)'
                            }}>
                                <MaterialTypography variant="caption" color="textSecondary" fontWeight="medium" sx={{ mb: 0.5 }}>
                                    Total Assigned
                                </MaterialTypography>
                                <MaterialTypography variant="h5" color="primary" fontWeight="bold">
                                    {taskStatus.total_assigned_hours || 0}
                                </MaterialTypography>
                            </MaterialBox>
                        </Grid>

                        <Grid size={{ xs: 6, sm: 4, md: 3, lg: 1.5 }}>
                            <MaterialBox sx={{
                                p: 2,
                                backgroundColor: '#e8f5e9',
                                borderRadius: '12px',
                                textAlign: 'center',
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.04)'
                            }}>
                                <MaterialTypography variant="caption" color="textSecondary" fontWeight="medium" sx={{ mb: 0.5 }}>
                                    Total Actual
                                </MaterialTypography>
                                <MaterialTypography variant="h5" color="success" fontWeight="bold">
                                    {taskStatus.total_actual_hours || 0}
                                </MaterialTypography>
                            </MaterialBox>
                        </Grid>

                        <Grid size={{ xs: 6, sm: 4, md: 3, lg: 1.5 }}>
                            <MaterialBox sx={{
                                p: 2,
                                backgroundColor: '#f3e5f5',
                                borderRadius: '12px',
                                textAlign: 'center',
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.04)'
                            }}>
                                <MaterialTypography variant="caption" color="textSecondary" fontWeight="medium" sx={{ mb: 0.5 }}>
                                    Total Tasks
                                </MaterialTypography>
                                <MaterialTypography variant="h5" color="dark" fontWeight="bold">
                                    {taskStatus.total_tasks || 0}
                                </MaterialTypography>
                            </MaterialBox>
                        </Grid>

                        <Grid size={{ xs: 6, sm: 4, md: 3, lg: 1.5 }}>
                            <MaterialBox sx={{
                                p: 2,
                                backgroundColor: '#e8f5e9',
                                borderRadius: '12px',
                                textAlign: 'center',
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.04)'
                            }}>
                                <MaterialTypography variant="caption" color="textSecondary" fontWeight="medium" sx={{ mb: 0.5 }}>
                                    Completed
                                </MaterialTypography>
                                <MaterialTypography variant="h5" color="success" fontWeight="bold">
                                    {taskStatus.completed_tasks || 0}
                                </MaterialTypography>
                            </MaterialBox>
                        </Grid>

                        <Grid size={{ xs: 6, sm: 4, md: 3, lg: 1.5 }}>
                            <MaterialBox sx={{
                                p: 2,
                                backgroundColor: '#e1f5fe',
                                borderRadius: '12px',
                                textAlign: 'center',
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.04)'
                            }}>
                                <MaterialTypography variant="caption" color="textSecondary" fontWeight="medium" sx={{ mb: 0.5 }}>
                                    In Progress
                                </MaterialTypography>
                                <MaterialTypography variant="h5" color="info" fontWeight="bold">
                                    {taskStatus.inprogress || 0}
                                </MaterialTypography>
                            </MaterialBox>
                        </Grid>

                        <Grid size={{ xs: 6, sm: 4, md: 3, lg: 1.5 }}>
                            <MaterialBox sx={{
                                p: 2,
                                backgroundColor: '#fff3e0',
                                borderRadius: '12px',
                                textAlign: 'center',
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.04)'
                            }}>
                                <MaterialTypography variant="caption" color="textSecondary" fontWeight="medium" sx={{ mb: 0.5 }}>
                                    On Hold
                                </MaterialTypography>
                                <MaterialTypography variant="h5" color="warning" fontWeight="bold">
                                    {taskStatus.onhold || 0}
                                </MaterialTypography>
                            </MaterialBox>
                        </Grid>

                        <Grid size={{ xs: 6, sm: 4, md: 3, lg: 1.5 }}>
                            <MaterialBox sx={{
                                p: 2,
                                backgroundColor: '#ffebee',
                                borderRadius: '12px',
                                textAlign: 'center',
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.04)'
                            }}>
                                <MaterialTypography variant="caption" color="textSecondary" fontWeight="medium" sx={{ mb: 0.5 }}>
                                    Aborted
                                </MaterialTypography>
                                <MaterialTypography variant="h5" color="error" fontWeight="bold">
                                    {taskStatus.abort || 0}
                                </MaterialTypography>
                            </MaterialBox>
                        </Grid>

                        <Grid size={{ xs: 6, sm: 4, md: 3, lg: 1.5 }}>
                            <MaterialBox sx={{
                                p: 2,
                                backgroundColor: '#f5f5f5',
                                borderRadius: '12px',
                                textAlign: 'center',
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.04)'
                            }}>
                                <MaterialTypography variant="caption" color="textSecondary" fontWeight="medium" sx={{ mb: 0.5 }}>
                                    Not Started
                                </MaterialTypography>
                                <MaterialTypography variant="h5" color="textSecondary" fontWeight="bold">
                                    {taskStatus.notstarted || 0}
                                </MaterialTypography>
                            </MaterialBox>
                        </Grid>
                    </Grid>
                </MaterialBox>
            )}

            <EmployeeTaskTable
                columns={[
                    { header: 'Task Id', key: 'task_code', showDisplay: true },
                    { header: 'Project', key: 'project_name', showDisplay: true },
                    { header: 'Module', key: 'module_name', showDisplay: true },
                    { header: 'Task', key: 'task_title', showDisplay: true },
                    { header: 'Date', key: 'start_date', showDisplay: true },
                    { header: 'Actual Hours', key: 'actual_hours', showDisplay: true },
                    { header: 'Milestone', key: 'milestone_name', showDisplay: false },
                    { header: 'Team', key: 'teams', showDisplay: false },
                    { header: 'Actual Start Date', key: 'actual_start_date', showDisplay: false },
                    { header: 'Actual End Date', key: 'actual_end_date', showDisplay: false },
                    { header: 'Priority', key: 'priority_level', showDisplay: false },
                    { header: 'Created By', key: 'task_creater_name', showDisplay: false },
                    { header: 'Reason', key: 'reason', showDisplay: false },
                    { header: 'Task Cancel Reason', key: 'cancel_reason', showDisplay: false },
                    { header: 'Task Hold Date', key: 'hold_date', showDisplay: false },
                    { header: 'Reason Hours', key: 'reason_hours', showDisplay: false },
                    { header: 'Task Description', key: 'task_describtion', showDisplay: false },
                ]}
                data={employeeTaskData}
                onTaskUpdate={() => fetchEmployeeTask(currentPage)}
                totalRows={totalRows}
                currentPage={currentPage}
                onPageChange={(page) => {
                    setCurrentPage(page);
                    fetchEmployeeTask(page);
                }}
                sortConfig={sortConfig}
                onSort={(key) => {
                    setSortConfig(prev => ({
                        key,
                        direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
                    }));
                    setCurrentPage(1);
                }}
            />

        </DashboardLayout >
    )
}

export default EmployeeTask